import React from 'react';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { TrendsSeriesPoint } from '../../types/ReportsTrends';

const TrendsSparkline: React.FC<{ data: TrendsSeriesPoint[] }> = ({ data }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const formatMonthTick = (value: string) => {
    if (!value) return '';
    const monthPart = value.split('-')[1];
    return monthPart ? monthPart : value;
  };

  return (
    <div style={{ width: '100%', height: isSmallScreen ? 280 : 320 }}>
      <ResponsiveContainer>
        <LineChart data={data} margin={{ top: 8, right: 8, left: 0, bottom: isSmallScreen ? 2 : 8 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="month"
            interval={isSmallScreen ? 2 : 0}
            tickFormatter={formatMonthTick}
            minTickGap={isSmallScreen ? 20 : 12}
            tick={{ fontSize: isSmallScreen ? 11 : 12 }}
          />
          <YAxis tick={{ fontSize: isSmallScreen ? 11 : 12 }} />
          <Tooltip />
          <Legend wrapperStyle={{ fontSize: isSmallScreen ? 11 : 12 }} iconSize={isSmallScreen ? 10 : 14} />
          <Line type="monotone" dataKey="income" name="Income" dot={false} />
          <Line type="monotone" dataKey="expense" name="Expenses" dot={false} />
          <Line type="monotone" dataKey="savings" name="Transfers" dot={false} />
          <Line type="monotone" dataKey="net" name="Net" dot={false} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrendsSparkline;
